export default "__VITE_ASSET__6f91a783__"